let errorHandler = null;

export function setGlobalErrorHandler(handler) {
  errorHandler = typeof handler === 'function' ? handler : null;
}

export function openGlobalError(error, retryFn = null) {
  if (!errorHandler) return false;

  if (typeof retryFn === 'function') {
    errorHandler(error, retryFn);
  } else {
    errorHandler(error);
  }

  return true;
}
